module.exports = __webpack_public_path__ + "static/media/setup_sales_opport.4990c391.webp";